import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogDescription } from '../ui/dialog';
import { useDispatch, useSelector } from "react-redux";
import { hidePopup } from '../../store/uiSlice';
import { Button } from '../ui/button';

const ConfirmPopup = () => {
    let { 
        title, message, action, 
        payload, negativeAction, negativePayload 
    } = useSelector(state => state.ui.popup);
    let dispatch = useDispatch();

    const close = (e) => {
        if (e) e.preventDefault();
        dispatch(hidePopup());
    };

    const positiveClick = (e) => {
        e.preventDefault();
        close();
        dispatch({ type: action, payload: payload });
    }

    const negativeClick = (e) => {
        e.preventDefault();
        close();
        dispatch({ type: negativeAction, payload: negativePayload });
    }

    const positiveLabel = negativeAction ? 'Yes' : 'OK';

    return (
        <Dialog open={!!action} onOpenChange={close}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    {message && <DialogDescription>{message}</DialogDescription>}
                </DialogHeader>
                <DialogFooter>
                    {negativeAction && (
                        <Button variant="outline" onClick={negativeClick} type="button">
                            No
                        </Button>
                    )}
                    <Button onClick={positiveClick} type="button">
                        {positiveLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmPopup; 